<div>
  <ng-container *ngFor="let tempIfcFile of tempIfcFiles">
    <mat-card class="banner-success">
      <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
        <div>Processing: {{ tempIfcFile.fileName }}</div>
      </mat-card-content>
    </mat-card>
  </ng-container>
  <ng-container *ngFor="let tempIfcFileError of tempIfcFileErrors">
    <mat-card class="banner-error" *ngFor="let error of tempIfcFileError?.errorMessages">
      <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
        <div>Upload error: {{ error }}</div>
        <button mat-icon-button color="clear" aria-label="Delete" (click)="clearError(tempIfcFileError)">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>